<mat-spinner [diameter]="diameter()" [style.--mat-progress-spinner-active-indicator-color]="styleService.styles().spinner.color"></mat-spinner>
